import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface PostItemsProps extends CacheProps {
  page: number
  limit: number
  typeId?: number
  searchQuery?: string
}

const postItemsApi = async ({ typeId, page, limit, searchQuery = undefined, ...rest }: PostItemsProps) => {
  const response = await fetchApi({
    method: 'GET',
    URL: {
      pathname: routes['api.posts.index'],
      query: {
        limit: limit,
        sort: 'id',
        direction: 'desc',
        page: page,
        type_id: typeId,
        title: searchQuery,
      },
    },
    ...rest,
  });
  return response?.data;
};

export default postItemsApi;
